import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { OVERLAY_DATA } from 'src/app/shared/services/dynamic-overlay/dynamic-overlay.service';
import { SplitButtonMenuItem } from './split-button.dto';

@Component({
  selector: 'app-split-button-menu',
  standalone: true,
  imports: [TranslateModule, MatButtonModule, MatIconModule],
  template: `
    <div class="custom-context-menu-wrapper d-flex flex-column gap-2 p-2">
      @for (item of menuItems; track item) {
        <button class="justify-content-start" mat-flat-button (click)="onItemClick(item)">
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          <span>{{ item.text | translate }}</span>
        </button>
      }
    </div>
  `,
})
export class SplitButtonMenuComponent {
  @Output() itemSelected = new EventEmitter<SplitButtonMenuItem>();
  public menuItems: SplitButtonMenuItem[] = inject(OVERLAY_DATA);

  onItemClick(item: SplitButtonMenuItem): void {
    this.itemSelected.emit(item);
  }
}
